import React, { useState, useEffect, useMemo } from 'react';
import Carousel from '../components/carousel.js';
import ListFeed from '../components/list/list-feed.js';
import HomeFeatureShortcuts from '../components/home/HomeFeatureShortcuts.js';
import HomeWidgetPopularPosts from '../components/home/HomeWidgetPopularPosts.js';
import HomeWidgetPostStats from '../components/home/HomeWidgetPostStats.js';
import HomeWidgetGigTasks from '../components/home/HomeWidgetGigTasks.js';
import HomeInfoPanel from '../components/home/HomeInfoPanel.js';
import { useTranslation } from '../i18n/useTranslation';

import notice01 from '../asset/image/notice/01.png';
import notice02 from '../asset/image/notice/02.png';
import notice03 from '../asset/image/notice/03.png';

const STORAGE_KEY_WIDGETS = 'astrantis_home_widgets';
const DEFAULT_WIDGETS = { showPopularPosts: true, showMyPostStats: true, showMyGigTasks: true };

function loadWidgets() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY_WIDGETS);
        return raw ? { ...DEFAULT_WIDGETS, ...JSON.parse(raw) } : DEFAULT_WIDGETS;
    } catch {
        return DEFAULT_WIDGETS;
    }
}

function SectionHeader({ title }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--color-text)' }}>{title}</span>
            <div style={{ flex: 1, height: 1, background: 'var(--color-monotone-2)' }} />
        </div>
    );
}

function DashboardPanel({ title, children }) {
    return (
        <div style={{
            background: 'var(--color-card)',
            border: '1px solid var(--color-monotone-2)',
            borderRadius: 14,
            padding: '16px 18px',
            display: 'flex', flexDirection: 'column', gap: 10,
            minHeight: 160,
        }}>
            <SectionHeader title={title} />
            {children}
        </div>
    );
}

const NOTICE_META = [
    { src: notice01, link: '/notice/1', color: '#1c1826', noticeKey: '1' },
    { src: notice02, link: '/notice/2', color: '#afdcf9', noticeKey: '2' },
    { src: notice03, link: '/notice/3', color: '#eed3d4', noticeKey: '3' },
];

function Home(){
    const { t } = useTranslation();

    const noticeSlides = useMemo(() => NOTICE_META.map((item) => ({
        ...item,
        title: t(`homePage.notice.${item.noticeKey}.title`),
        description: t(`homePage.notice.${item.noticeKey}.description`),
    })), [t]);

    const [widgets, setWidgets] = useState(DEFAULT_WIDGETS);

    useEffect(() => {
        setWidgets(loadWidgets());
        const onStorage = (e) => {
            if (e.key === STORAGE_KEY_WIDGETS) setWidgets(loadWidgets());
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const showDashboard = widgets.showMyPostStats || widgets.showMyGigTasks;

    return(
        <div className='box-col gap10 pd0'>
            <Carousel images={noticeSlides}/>
            <HomeFeatureShortcuts />
            <hr/>

            {/* 인기 포스트 */}
            {widgets.showPopularPosts && (
                <>
                    <section className='box-col gap10 pd0'>
                        <HomeWidgetPopularPosts />
                    </section>
                    <hr />
                </>
            )}

            {/* 내 포스트 통계 + GIG 업무 현황 — 2컬럼 그리드 */}
            {showDashboard && (
                <>
                    <section className="home-dashboard-grid">
                        {widgets.showMyPostStats && (
                            <DashboardPanel title={t('homePage.widgets.postStats')}>
                                <HomeWidgetPostStats />
                            </DashboardPanel>
                        )}
                        {widgets.showMyGigTasks && (
                            <DashboardPanel title={t('homePage.widgets.gigTasks')}>
                                <HomeWidgetGigTasks />
                            </DashboardPanel>
                        )}
                    </section>
                    <hr />
                </>
            )}

            <div className="home-feed-row">
                <div className="home-feed-column">
                    <ListFeed excludeMediaFormats showMediaCarousel homeFeed />
                </div>
                <HomeInfoPanel />
            </div>
        </div>
    );
}
export default Home;
